import { render, staticRenderFns } from "./BaseOverview.vue?vue&type=template&id=0f40ad2a&scoped=true"
import script from "./BaseOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseOverview.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f40ad2a",
  null
  
)

export default component.exports